import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import { Heart } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [slug] = useState(item?.slug);
  const [title] = useState(item?.title);
  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null,
  );
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(
    Boolean,
  );

  const primaryImage = useMemo(
    () => galleryImages[0] || item?.thumbnail,
    [galleryImages, item?.thumbnail],
  );

  const hoverImage = useMemo(
    () => galleryImages[1] || galleryImages[0] || item?.thumbnail,
    [galleryImages, item?.thumbnail],
  );

  const hasDiscount =
    activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

  const isOutOfStock = activeStock <= 0;

  const handleAddToCart = (e) => {
    const action = e.currentTarget.getAttribute("data-action");

    try {
      addToCart(item?._id, 1, activeVariantId || "");

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();

    const isLoggedIn = Auth.getToken();

    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  return (
    <div className="custom-product-card">
      {hasDiscount && (
        <div className="custom-product-badge">
          {Math.round(activeDiscount)}% OFF
        </div>
      )}

      <div
        className={`custom-product-icons wishlist-btn ${isWishlisted ? "active" : ""}`}
        onClick={handleWishlistToggle}
        aria-label="Add to wishlist"
      >
        <Heart
          size={20}
          strokeWidth={1.5}
          fill={isWishlisted ? "currentColor" : "none"}
          className="custom-product-icon"
        />
      </div>

      <div className="custom-product-image-wrapper">
        <Link to={`/shop/${slug}`} className="custom-product-image-link">
          <img
            src={primaryImage}
            alt={title}
            loading="lazy"
            className="custom-product-image custom-product-image-main"
          />
          <img
            src={hoverImage}
            alt={title}
            loading="lazy"
            className="custom-product-image custom-product-image-hover"
          />
        </Link>

        {!isOutOfStock && config?.productVisibility === "cart" && (
          <>
          <button
            className="custom-hover-cart-btn"
            data-id={item?._id}
            data-price={activePrice}
            data-variant={activeVariantId || ""}
            data-quantity={1}
            data-action="cart"
            data-bs-toggle="offcanvas"
            data-bs-target="#shoppingCartCanvas"
            onClick={handleAddToCart}
          >
            Add to Bag
          </button>
          </>
        )}
      </div>

      {/* <div className="product-details text-center px-3 py-3">
        <h4 className="custom-product-title ">{title}</h4>
         <p className="custom-product-title-subtitle">{item.shortDescription}</p>
        

        <div className="d-flex align-items-center justify-content-left gap-2">
          <p className="custom-product-price mb-0">₹{activePrice}</p>
      
           {Number(activeMrp) > Number(activePrice) && (
    <p className="custom-product-price-del mb-0">
      ₹{activeMrp}
    </p>
  )}
        </div>

        {isOutOfStock && (
          <p className="text-danger fw-bold mt-2 mb-0">Out of Stock</p>
        )}
      </div> */}
      <div className="s px-0 ">
        <h5 className="custom-product-title">
    {title}
  </h5>
  {/* <p className="custom-product-category">
    {item?.shortDescription}
  </p> */}

  

  <div className="custom-product-price-wrap">
    <p className="custom-product-price mb-0">
      ₹{activePrice}
    </p>

    {Number(activeMrp) > Number(activePrice) && (
      <p className="custom-product-price-del mb-0">
        ₹{activeMrp}
      </p>
    )}
  </div>

  {isOutOfStock && (
    <p className="text-danger fw-bold mt-2 mb-0">
      Out of Stock
    </p>
  )}
</div>
    </div>
  );
}

export default Card;
